import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import { UntypedFormGroup, NgForm } from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { Observable, Subscription } from 'rxjs';
import { DashboardService } from '../../dashboard.service';
import { AdminLanguageService } from '../../services/admin-language-service/admin-language.service';
import {ProfileImageCropperDialogComponent} from '../../profile-image-cropper-dialog/profile-image-cropper-dialog.component';

@Component({
    selector: 'app-edit-dialog',
    templateUrl: './edit-dialog.component.html',
    styleUrls: ['./edit-dialog.component.scss'],
    standalone: false
})
export class EditDialogComponent implements OnInit {

  downloadUrl$: Observable<string>
  downloadUrlSub: Subscription
  selectedImage: File = null
  labels;
  labelsSub: Subscription;
  err: boolean = false
  trainers
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  constructor(public snackBar: MatSnackBar, public dialog: MatDialog, public dialogRef: MatDialogRef<EditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,private dashboardService:DashboardService, private adminLanguageService:AdminLanguageService) { }
    @ViewChild('editForm') editForm:NgForm
    @ViewChild('imageUpload') imageUpload: ElementRef

  onSubmit(){
    console.log(this.editForm.value.userName)
    console.log(this.editForm.value.email)
    if (this.editForm.value.userName == "" || this.editForm.value.firstName == "" || this.editForm.value.password == "" || this.editForm.value.departmentId == "" || this.editForm.value.email == "") {
      // this.errorClass = "errorClass"
      this.err = true
      this.snackBar.open(this.labels.lblAllfieldsError, 'OK', {
        verticalPosition: 'top',
        horizontalPosition: 'end',
        duration: 5000
      })
    }else {
      let trainer = {
        _id: this.data._id,
        //userName: this.editForm.value.userName,
        firstName: this.editForm.value.firstName,
        lastName: this.editForm.value.lastName,
        email: this.editForm.value.email,
        dateOfBirth: this.editForm.value.dateOfBirth,
        about: this.editForm.value.about,
        profileImagePath: ""//this.data.profileImagePath,
      }

      if(this.emailAlreadyExists(this.editForm.value.email)){
        this.snackBar.open(this.labels.lblEmailAlreadyExists, 'OK', {
          verticalPosition: 'top',
          horizontalPosition: 'end',
          duration: 5000
        })
      }
      /*else if(this.userNameAlreadyExists(this.editForm.value.userName)){
        this.snackBar.open(this.labels.lblUserNameAlreadyExists, 'OK', {
          verticalPosition: 'top',
          horizontalPosition: 'end',
          duration: 5000
        })
      }*/
      else{
      if (this.selectedImage == null) {
        delete trainer.profileImagePath
        this.editTrainer(trainer)
            setTimeout(() => {
              this.dialogRef.close()
              this.snackBar.open(this.labels.lblTrainerEdited, 'OK', {
                verticalPosition: 'top',
                horizontalPosition: 'end',
                duration: 5000  })
            }, 2000)
      }
      else {
        let imagesData = new FormData()
        imagesData.append('photo', this.selectedImage)
        this.dashboardService.uploadImage(imagesData).subscribe((response: { photo, coverPhoto }) => {
          if (response.photo) {
            trainer.profileImagePath = response.photo
          }

          this.editTrainer(trainer)
          this.dialogRef.close()
        })
      }
      }
    }
  }
  onNoClick(): void {
   this.dialogRef.close();
  }
  ngOnInit(): void {
    this.err = false;
    this.getLang()
    this.getTrainers()
  }
  goToNextStep(stepper: MatStepper){
    if (this.editForm.value.userName == "" || this.editForm.value.firstName == "" || this.editForm.value.password == "") {
      this.err = true
      this.snackBar.open(this.labels.lblAllfieldsError, 'OK', {
        verticalPosition: 'top',
        horizontalPosition: 'end',
        duration: 5000
      })
    }else{
      stepper.next()
    }
  }

  goBack(stepper: MatStepper){
    stepper.previous()
  }
  getLang(){
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
      })
  }

  editTrainer(data){
    this.dashboardService.editTrainer(data).subscribe((response)=>{
      console.log(response)
      this.getTrainers()
    })
  }

  onImageChanged(event) {
    let selectedFile = event.target.files[0]
    let ext = selectedFile.name.split(".").pop()
    if (ext == "jpg" || ext == "jpeg" || ext == "png") {
      var iConvert = (selectedFile.size / 1024 / 1024).toFixed(2);
      let number:number = +iConvert
      if(number <= 250){
        this.selectedImage = event.target.files[0]
        const dialogRef = this.dialog.open(ProfileImageCropperDialogComponent, {
          width: "500px",
          height: "600px",
          data: event
        })

        dialogRef.afterClosed().subscribe((result) => {
          if (result == null) {
            this.imageUpload.nativeElement.value = ""
            this.updateImageData()
          }
          else {
            this.selectedImage = result
            this.data.imageName = this.selectedImage.name
            this.data.imagePath = ""
          }
        })
      }
      else {
        this.snackBar.open(this.labels.lblMaxFileSizeImage, 'OK', {
          verticalPosition: 'top',
          horizontalPosition: 'end',
          duration: 5000
        })
        this.imageUpload.nativeElement.value = ""
      }

    }
    else {
      this.snackBar.open(this.labels.lblWrongFormat + " " + this.labels.lblSupportedFormatsImage, 'OK', {
        verticalPosition: 'top',
        horizontalPosition: 'end',
        duration: 5000
      })
      this.imageUpload.nativeElement.value = ""
    }
  }

  updateImageData() {
    this.data.imagePath = null
    this.selectedImage = null
  }

  getTrainers(){
    this.dashboardService.getTrainers().subscribe((trainers)=>{
      console.log(trainers)
      this.trainers = trainers
      this.trainers = this.trainers.filter((t) => t._id != this.data._id)
  })
}

emailAlreadyExists(email: string): boolean {
  for (let index = 0; index < this.trainers.length; index++) {
    if (this.trainers[index].email == email) {
      return true
    }
  }
  return false
}

userNameAlreadyExists(userName: string): boolean {
  for (let index = 0; index < this.trainers.length; index++) {
    if (this.trainers[index].userName == userName) {
      return true
    }
  }
  return false
}
}
